
























import { Component, Vue } from "vue-property-decorator";
@Component
export default class ContentHeaderQuickActions extends Vue {
  public get actions() {
    return [
      {
        method: () => this.$store.dispatch("data/clients/openAddClientModal"),
        if: this.$userCan("create_client"),
        icon: "users",
        label: this.$t("_action.add_object", {
          object: (this.$t("_.client") as string).toLowerCase()
        })
      },
      {
        method: () => this.$store.dispatch("data/leads/openAddLeadModal"),
        if: this.$userCan("create_lead"),
        icon: "address-book",
        label: this.$t("_action.add_object", {
          object: (this.$t("_.lead") as string).toLowerCase()
        })
      },
      {
        method: () => this.$store.dispatch("data/contracts/startNewOrder"),
        if: this.$userCan("staff_create_order"),
        icon: "shopping-basket",
        label: this.$t("_action.add_object", {
          object: (this.$t("_.order") as string).toLowerCase()
        })
      },
      {
        method: () => this.$store.dispatch("data/tickets/openNewTicketModal"),
        if: this.$userCan("create_ticket"),
        icon: "comments",
        label: this.$t("_action.add_object", {
          object: (this.$t("_.ticket") as string).toLowerCase()
        })
      }
    ];
  }
}
